import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AppMainComponent } from "./app.main.component";
import { Router } from "@angular/router";
import { AccountUserService } from "./service/account.service";
import { ConfirmationService, Message, MessageService } from "primeng/api";
import { ConfigurationService } from "./configurations/configurationService";
import { OverdueNotificationService } from "./service/overdue-notification.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormErrorHandler } from "./modules/shared/helpers/form-error-handler.helper";
import { uploadFiles, validateFiles } from "./shared/upload-files";
import { Status } from "./models/statusEnums";
import { Subject } from "rxjs";
import { FileUpload } from "primeng/fileupload";
import { AppMainService } from "./app-main.service";
import { ReportMouduleName } from "./modules/shared/models/reportIssue-module-name";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-topbar",
    templateUrl: "./app.topbar.component.html",
    styleUrls: ["./app.component.css"]
})
export class AppTopBarComponent implements OnInit, OnDestroy {

    @ViewChild('fileInput') fileInput: FileUpload;
    private ngUnsubscribe = new Subject<void>();
    displayReportIssue = false;
    uploadedFiles: any[] = [];
    reportForm: FormGroup;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
    isReportIssueValidate: boolean = false;
    settingsBar = false;
    flatLayouts: any[];
    specialLayouts: any[];
    themes: any[];
    mobile = false;
    selectedNodes2;
    allReportModules: any;
    nodes3 = [
        {
            label: "Documents",
            data: "Documents Folder",
            expandedIcon: "pi pi-folder-open",
            collapsedIcon: "pi pi-folder",
            children: [
                {
                    label: "Work",
                    data: "Work Folder",
                    expandedIcon: "pi pi-folder-open",
                    collapsedIcon: "pi pi-folder",
                    children: [
                        {
                            label: "Expenses.doc",
                            icon: "pi pi-file",
                            data: "Expenses Document",
                        },
                        {
                            label: "Resume.doc",
                            icon: "pi pi-file",
                            data: "Resume Document",
                        },
                    ],
                },
                {
                    label: "Home",
                    data: "Home Folder",
                    expandedIcon: "pi pi-folder-open",
                    collapsedIcon: "pi pi-folder",
                    children: [
                        {
                            label: "Invoices.txt",
                            icon: "pi pi-file",
                            data: "Invoices for this month",
                        },
                    ],
                },
            ],
        },
        {
            label: "Pictures",
            data: "Pictures Folder",
            expandedIcon: "pi pi-folder-open",
            collapsedIcon: "pi pi-folder",
            children: [
                {
                    label: "barcelona.jpg",
                    icon: "pi pi-image",
                    data: "Barcelona Photo",
                },
                {
                    label: "logo.jpg",
                    icon: "pi pi-file",
                    data: "PrimeFaces Logo",
                },
                {
                    label: "primeui.png",
                    icon: "pi pi-image",
                    data: "PrimeUI Logo",
                },
            ],
        },
        {
            label: "Movies",
            data: "Movies Folder",
            expandedIcon: "pi pi-folder-open",
            collapsedIcon: "pi pi-folder",
            children: [
                {
                    label: "Al Pacino",
                    data: "Pacino Movies",
                    children: [
                        {
                            label: "Scarface",
                            icon: "pi pi-video",
                            data: "Scarface Movie",
                        },
                        {
                            label: "Serpico",
                            icon: "pi pi-file-video",
                            data: "Serpico Movie",
                        },
                    ],
                },
                {
                    label: "Robert De Niro",
                    data: "De Niro Movies",
                    children: [
                        {
                            label: "Goodfellas",
                            icon: "pi pi-video",
                            data: "Goodfellas Movie",
                        },
                        {
                            label: "Untouchables",
                            icon: "pi pi-video",
                            data: "Untouchables Movie",
                        },
                    ],
                },
            ],
        },
    ];

    // Hard-coded module names
    modules: any[] = [
        {
            label: 'CRM',
            //   value: 'CRM',
            selectable: false,
            children: [
                { label: 'Account', value: { moduleId: 2, moduleName: 'Account' } },
                { label: 'Lead', value: { moduleId: 1, moduleName: 'Lead' } },
                { label: 'Contact', value: { moduleId: 40, moduleName: 'Contact' } },
                { label: 'Cases', value: { moduleId: 8, moduleName: 'Cases' } },
                { label: 'Opportunity', value: { moduleId: 3, moduleName: 'Opportunity' } },
            ],
        },
        {
            label: 'FSM',
            //   value: 'FSM',
            selectable: false,
            children: [
                { label: 'Territory', value: { moduleId: 5, moduleName: 'Territory' } },
                { label: 'Routes', value: { moduleId: 6, moduleName: 'Routes' } },
                { label: 'Questionnaire', value: { moduleId: 165, moduleName: 'Questionnaire' } },
            ],
        },
        {
            label: 'Inventory',
            //   value: 'Inventory',
            selectable: false,
            children: [
                { label: 'Sales', value: { moduleId: 245, moduleName: 'Sales' } },
                { label: 'Products', value: { moduleId: 79, moduleName: 'Products' } },
                { label: 'Purchases', value: { moduleId: 251, moduleName: 'Purchases' } },
                { label: 'Location', value: { moduleId: 127, moduleName: 'Location' } },
            ],
        },
    ];

    globalSearchInfoTooptip: string = '';
    notificationActive = true;
    assestBaseUrl: string = environment.assestsBasePath;

    constructor(
        public app: AppMainComponent,
        private router: Router,
        private service: AccountUserService,
        private configurationService: ConfigurationService,
        private messageService: MessageService,
        private fb: FormBuilder,
        public appMainService: AppMainService,
    ) { }

    ngOnInit() {
        this.reportIssueForm();
        this.globalSearchInfoTooptip = `-By default a keyword will be searched across all the modules

        -To search in specific module(s), type @ to select the specific module

        -To search a keyword in specific field, type @ to select. the field after selecting the module`;

        if (window.screen.width > 500) {
            this.mobile = true;
        }

        this.flatLayouts = [
            { name: "dark", color: "#3b3b48" },
            { name: "turquoise", color: "#04838f" },
            { name: "green", color: "#1e8455" },
            { name: "blue", color: "#2461cc" },
            { name: "rose", color: "#79425a" },
            { name: "teal", color: "#427976" },
            { name: "bluegrey", color: "#37474f" },
            { name: "purple", color: "#5d4279" },
            { name: "white", color: "#ffffff" },
        ];

        this.specialLayouts = [
            { name: "cosmic", color1: "#517fa4", color2: "#243949" },
            { name: "lawrencium", color1: "#302b63", color2: "#201B4C" },
            { name: "couple", color1: "#3a6186", color2: "#89253e" },
            { name: "stellar", color1: "#7474BF", color2: "#348AC7" },
            { name: "beach", color1: "#00cdac", color2: "#02aab0" },
            { name: "flow", color1: "#136a8a", color2: "#267871" },
            { name: "fly", color1: "#7b4397", color2: "#b22f64" },
            { name: "nepal", color1: "#614385", color2: "#516395" },
            { name: "celestial", color1: "#734b6d", color2: "#734b6d" },
        ];

        this.themes = [
            { name: "green", color: "#9fd037" },
            { name: "teal", color: "#12b886" },
            { name: "blue", color: "#3ebaf8" },
            { name: "amber", color: "#f7cb00" },
            { name: "purple", color: "#966af1" },
            { name: "turquoise", color: "#2ab1be" },
            { name: "bluegrey", color: "#546E7A" },
            { name: "red", color: "#CE1800" },
        ];

    }

    changeTheme(theme) {
        this.app.currentUser.theme = theme;
        this.changeThemeSettings();
    }

    changeThemeSettings() {
        const themeLink: HTMLLinkElement = document.getElementById(
            "theme-css"
        ) as HTMLLinkElement;
        const href =
            "assets/theme/theme-" + this.app.currentUser.theme + ".css";
        this.replaceLink(themeLink, href);
    }

    changeLayout(layout) {
        this.app.currentUser.layout = layout;
        this.changeLayoutSettings();
    }

    changeLayoutSettings() {
        const layoutLink: HTMLLinkElement = document.getElementById(
            "layout-css"
        ) as HTMLLinkElement;
        const href =
            "assets/layout/css/layout-" + this.app.currentUser.layout + ".css";
        this.replaceLink(layoutLink, href);
    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }

    replaceLink(linkElement, href) {
        if (this.isIE()) {
            linkElement.setAttribute("href", href);
        } else {
            const id = linkElement.getAttribute("id");
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute("href", href);
            cloneLinkElement.setAttribute("id", id + "-clone");

            linkElement.parentNode.insertBefore(
                cloneLinkElement,
                linkElement.nextSibling
            );

            cloneLinkElement.addEventListener("load", () => {
                linkElement.remove();
                cloneLinkElement.setAttribute("id", id);
            });
        }
    }

    switchedUser() {
        this.router.navigate(["/"]);
        this.changeThemeSettings();
        this.changeLayoutSettings();
    }

    switchedUser1() {
        let e = <any>document.getElementById("changedUser");
        let id = e.value;
        for (let u of this.app.usersList) {
            if (u.id == id) {



                this.app.currentUser = u;
                break;
            }
            this.switchedUser();
        }
    }

    settings(event) {
        this.app.configActive = !this.app.configActive;
        this.app.configClick = true;
    }

    changePasswordDisplay = false;

    tempPassword = {
        emailId: "",
        oldPassword: "",
        newPassword: "",
        newPassword1: "",
    };

    changePassword() {
        this.tempPassword = {
            emailId: this.app.user.emailId,
            oldPassword: "",
            newPassword: "",
            newPassword1: "",
        };

        this.changePasswordDisplay = true;
    }

    updatePassword() {
        let response = {
            emailId: this.tempPassword.emailId,
            oldPassword: this.app.encryptData(this.tempPassword.oldPassword),
            newPassword: this.app.encryptData(this.tempPassword.newPassword),
        };

        if (response.oldPassword == response.newPassword) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "You can't have the same Password as old one",
            });
        } else {
            this.service.updatePassword(response).then((res) => {
                let ress = <any>res;
                if (ress.statusCode == 400) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: ress.error?.message,
                    });
                }else if(ress.statusCode == 0){
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: ress?.message,
                    });
                } else {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: ress.message,
                    });
                    this.changePasswordDisplay = false;
                }
            });
        }
    }


    reportIssueForm() {
        this.detailsFormErrors = {};
        this.reportForm = this.fb.group({
            description: ['', [Validators.required]],
            attachments: [null],
        });
        this.formErrorHandler.handleErrors(
            this.reportForm,
            this.detailsFormErrors,
            {
                description: {
                    required: "Feedback is required",
                }
            }
        );
    }

    //report issue Add attachement
    onUpload(files: File[]) {
        if (typeof Worker !== undefined) {
            for (let file of files) {
                const isFileAlreadyUploaded = this.uploadedFiles.some(el => el.name === file.name);
                if (isFileAlreadyUploaded) {
                    // File is already selected
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: `${file.name} is already selected. Please choose a different file.`
                    });
                } else {

                    let errors = validateFiles(file, 5, this.allowedExtensions);

                    if (errors.length > 0) {
                        for (let error of errors) {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error.fileName + ": " + error.error
                            });
                        }
                    } else {
                        //changing form array
                        uploadFiles(file, ({ name, content, size, extension }) => {
                            const dataToUpload = {
                                "id": 0,
                                "createdSource": this.app.user.userIP,
                                "updatedSource": this.app.user.userIP,
                                "createdBy": this.app.user.userId,
                                "updatedBy": this.app.user.userId,
                                "createdDate": new Date(),
                                "updatedDate": new Date(),
                                "name": name,
                                "guidName": "string",
                                "location": "string",
                                "content": content,
                                "extension": extension,
                                "sizeInBytes": size,
                                "description": "string",
                                "statusId": Status.Active,
                                "isValid": true,
                                "validFromDate": null,
                                "validToDate": null
                            }
                                ;

                            const foundFile = this.uploadedFiles.find(el => el.name === file.name);
                            if (!foundFile) {
                                this.uploadedFiles.push(dataToUpload);
                            }
                        });
                    }
                }
            }
        }
    }

    saveReportIssue() {
        if (this.reportForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            return;
        }
        const localStorageData = localStorage.getItem("LionO360_Object");
        let accountObject = JSON.parse(localStorageData);
        accountObject = accountObject.find(item => item.name === "Account");
        this.appMainService.isShowSpinner('Report');
        const sendReportIssue: any = {
            moduleId: accountObject.id,
            moduleName: accountObject.name,
            description: this.reportForm.value.description,
            attachments: this.uploadedFiles ? this.uploadedFiles : [],
        };
        this.service.reportIssue(sendReportIssue).subscribe({
            next: (response) => {
                const res: any = response;
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: `Thanks for your feedback`,
                });
                this.appMainService.isHideSpinner('Report');
                this.closeReportIssue();
            },
            error: () => {
                this.appMainService.isHideSpinner('Report');
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: `Failed to submit your feedback....`,
                });
            },
        })

    }

    closeReportIssue() {
        this.reportIssueForm();
        this.uploadedFiles = [];
        this.displayReportIssue = false;
        this.fileInput?.clear();
    }

    displayReportIssueForm() {
        this.displayReportIssue = true;
        this.allReportModule();

    }


    deleteFile(field, index) {
        field.splice(index, 1);
    }

    allReportModule() {
        this.service.getReportIssueModule(this.app.user.organizationId, this.app.user.userId).subscribe({
            next: (response: any[]) => {
                let allReportModules: any[] = response || []
                const allModuleNameList: ReportMouduleName[] = [];
                allReportModules.map(item => {
                    let parentValue = {
                        label: item.moduleTypeName,
                        selectable: false,
                        value: null,
                        children: []
                    }
                    parentValue.children = item.children.map(children => ({
                        label: children.moduleName,
                        selectable: true,
                        value: children.moduleValue,
                        children: []
                    }))
                    allModuleNameList.push(parentValue);
                    this.modules = allModuleNameList
                })
            },
            error: () => {
                this.appMainService.isHideSpinner('Report');
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: `Failed To Load Module List..`,
                });
            }
        })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}


